
import { defineComponent, nextTick, onBeforeMount, Ref, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import ResetPasswordComponent from "../application/forms/ResetPassword.vue";
import ResetPasswordSuccess from "../application/forms/ResetPasswordSuccess.vue";
import ResetOptions from "../application/forms/ResetOptions.vue";
import IdentityForm from "../application/forms/IdentityForm.vue";
import { authenticationUseCases } from "../../../../domain/usecase/impl/authenticationUseCases";
import ModernInput from "../application/forms/modernInput.vue";
import InputPassword from "../application/forms/InputPassword.vue";
import { dispatchErrorBox } from "../mixins";
import { dispatchError } from "../../utils/error_handling";

export default defineComponent({
  components: {
    IdentityForm,
    ResetOptions,
    ResetPasswordSuccess,
    ResetPasswordComponent,
    ModernInput,
    InputPassword
  },
  setup() {
    /** Instance of the vuex store. */
    const store = useStore();

    /** An instance of a router. */
    const router = useRouter();

    /** The current type of the password input. */
    const currentType: Ref<string> = ref("password");

    /** The current password. */
    const password: Ref<string> = ref("");

    /** The current password confirmation. */
    const confirmation: Ref<string> = ref("");

    onBeforeMount(async () => {
      await nextTick(() => {
        const input = document.querySelector(
          "[data-password-input]"
        ) as HTMLInputElement;
        input.focus();
      });
    });

    const term: Ref<boolean> = ref(false);

    const acceptTerm = async (): Promise<void> => {
      await store.dispatch("authentication_module/acceptTerm");
    };

    /** Changes the user's password to a new one. */
    const changePassword = async (
      password: string,
      confirmation: string
    ): Promise<void> => {
      try {
        if (term.value) {
          await authenticationUseCases.changePassword(password, confirmation);
          await acceptTerm();
          await store.dispatch("miscellany_module/setSuccess", {
            message: "Senha alterada com sucesso!",
            changed: true
          });
          await router.push({ name: "dashboard" });
        } else {
          await dispatchErrorBox(
            "É necessário aceitar o Termo de Uso para prosseguir!"
          );
        }
      } catch (e) {
        await dispatchError(e);
      }
    };

    /** Toggles the password visibility by switching the input type
     * from password to text and vice-versa. */
    const togglePasswordVisibility = async (event: Event) => {
      const input = event.target as HTMLInputElement;
      const isVisible = input.checked;
      currentType.value = isVisible ? "text" : "password";
    };

    return {
      currentType,
      password,
      confirmation,
      term,
      changePassword,
      togglePasswordVisibility
    };
  }
});
